import React, {Component} from 'react';
import LuissButton from "../../../common_components/luiss_button/luiss_button";
import navbar_logo from "../../../assets/navbar_logo.svg";

import "./not_found.scss";
import {Translation} from "react-i18next";
import {TFunction} from "i18next";
import {Helmet} from "react-helmet";

const SVG_ID = "#svg_id";

interface NotFoundComponentProps {
    type: "TRANSLATION" | "PAGE";

    language: string;
    changeLanguage: (language: string) => void;
}

class NotFoundComponent extends Component<NotFoundComponentProps> {

    changeLanguage() {
        this.props.changeLanguage(this.props.language === "it" ? "en" : "it");
    }

    render() {
        let buttonProps = {};
        switch (this.props.type) {
            case "PAGE":
                buttonProps = { url: "/" };
                break;
            case "TRANSLATION":
                buttonProps = { action: () => this.changeLanguage() };
                break;
        }

        return (
            <Translation>
                {(t: TFunction) =>
                    <div className="not-found-block">
                        <Helmet defaultTitle="Luiss Guido Carli" >
                            <meta name="prerender-status-code" content="404" />
                            <meta name="robots" content="noindex" />
                            <meta http-equiv="Status" content="404 Not Found"/>
                        </Helmet>
                        <h1>{t(`NOT FOUND ${this.props.type} title`)}</h1>
                        <p>{t(`NOT FOUND ${this.props.type} subtitle`)}</p>
                        <svg className="navbar-logo">
                            <use xlinkHref={`${navbar_logo}${SVG_ID}`} />
                        </svg>
                        <LuissButton {...buttonProps}>
                            {t(`NOT FOUND ${this.props.type} backlink label`)}
                        </LuissButton>
                    </div>
                }
            </Translation>
        );
    }
}

export default NotFoundComponent;